import React from 'react';
import { usePageContent } from '../../hooks/usePageContent';

const HelpPage = () => {
  const { find } = usePageContent('help');
  const c = find('richText') || {};
  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.pageTitle || 'Custom Plates explained'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className="rich-text" dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }} />
      </div>
    </div>
  );
};

export default HelpPage;
